import React from 'react';
import { CommonChrome } from '@solarwinds-cloud/cloud-ui';
import AccountMenu from './account-menu';
import Search from './search';

const Header = (props) => {
  const {
    currentOrg,
    currentUser,
    environment,
    inverted,
    maxSearchResults,
    organizations,
    pathname,
    showSearch,
    showSwo,
    swicusOrgId,
    usesSso,
  } = props;

  return (
    <CommonChrome.Nav horizontal inverted={inverted}>
      <CommonChrome.HeaderNav inverted={inverted} productName='Papertrail' />
      {showSwo && (
        <a className='nav-link swo-button' href='/swo'>
          Migrate to SolarWinds Observability
        </a>
      )}
      {showSearch && (
        <Search inverted={inverted} maxResults={maxSearchResults} />
      )}
      {!usesSso && (
        <CommonChrome.AppSwitcher
          currentProduct='papertrail'
          environment={environment}
          features={{ crossActivation: true }}
          inverted={inverted}
          swicusOrgId={swicusOrgId}
        />
      )}
      <AccountMenu
        currentOrg={currentOrg}
        inverted={inverted}
        isAdmin={currentUser.admin}
        organizations={organizations}
        pathname={pathname}
        userName={currentUser.name}
        userEmail={currentUser.email}
      />
    </CommonChrome.Nav>
  );
};

export default Header;
